var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70876 4.58571C9.80598 4.575 9.90321 4.57143 10.0004 4.57143C11.8408 4.57143 13.3339 6.075 13.3339 8C13.3339 9.89286 11.8408 11.4286 10.0004 11.4286C8.12883 11.4286 6.66696 9.89286 6.66696 8C6.66696 7.9 6.67043 7.8 6.68085 7.7C7.00378 7.86071 7.3788 8 7.77812 8C9.00387 8 10.0004 6.975 10.0004 5.71429C10.0004 5.30357 9.86502 4.91786 9.70876 4.58571ZM16.6882 2.87857C18.3133 4.42857 19.4002 6.25357 19.9141 7.56071C20.0286 7.84286 20.0286 8.15714 19.9141 8.43929C19.4002 9.71429 18.3133 11.5393 16.6882 13.1214C15.0527 14.6857 12.8061 16 10.0004 16C7.19476 16 4.94813 14.6857 3.31334 13.1214C1.68827 11.5393 0.602114 9.71429 0.0854594 8.43929C-0.0284865 8.15714 -0.0284865 7.84286 0.0854594 7.56071C0.602114 6.25357 1.68827 4.42857 3.31334 2.87857C4.94813 1.31571 7.19476 0 10.0004 0C12.8061 0 15.0527 1.31571 16.6882 2.87857ZM10.0004 2.85714C7.2399 2.85714 5.00022 5.16071 5.00022 8C5.00022 10.8393 7.2399 13.1429 10.0004 13.1429C12.761 13.1429 15.0007 10.8393 15.0007 8C15.0007 5.16071 12.761 2.85714 10.0004 2.85714Z",
    fill: "#2DD0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEye);
export default __webpack_public_path__ + "static/media/blue-eye.c4eab232e957c3962414b1b4b2333b6d.svg";
export { ForwardRef as ReactComponent };